import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/SEO"
import PageIllustration from "../partials/PageIllustration"
import BlogSingle from "../components/BlogSingle"
import CalendlyBook from "../partials/CalendlyBook"

const Post = ({ data }) => {
  const post = data.ghostPost

  return (
    <>
      <SEO {...{ ghostData: post, pageType: "blogPost" }} />
      {/*  Page content */}
      <main className="flex-grow">
        {/*  Page illustration */}
        <div
          className="relative max-w-6xl mx-auto h-0 pointer-events-none"
          aria-hidden="true"
        >
          <PageIllustration />
        </div>

        {/*  Page sections */}
        <BlogSingle {...{ data }} />
        <CalendlyBook />
      </main>
    </>
  )
}

export default Post
export const postQuery = graphql`
  query GhostPostQuery($slug: String!, $published_at: Date) {
    ghostPost(slug: { eq: $slug }) {
      ...GhostPostFields
      featureImage {
        childImageSharp {
          gatsbyImageData(width: 1600, quality: 90, formats: [AUTO, WEBP])
        }
      }
      profileImage {
        childImageSharp {
          gatsbyImageData(
            width: 100
            height: 100
            quality: 90
            formats: [AUTO, WEBP]
          )
        }
      }
    }

    allGhostPost(
      limit: 3
      filter: { slug: { ne: $slug }, published_at: { lte: $published_at } }
    ) {
      edges {
        node {
          ...GhostPostFields
          featureImage {
            childImageSharp {
              gatsbyImageData(
                width: 352
                height: 198
                quality: 50
                formats: [AUTO, WEBP]
              )
            }
          }
          profileImage {
            childImageSharp {
              gatsbyImageData(
                width: 40
                height: 40
                quality: 90
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
    }
  }
`
